import { render } from "./MentorshipPage.vue?vue&type=template&id=7140ede0&scoped=true"
import script from "./MentorshipPage.vue?vue&type=script&lang=js"
export * from "./MentorshipPage.vue?vue&type=script&lang=js"

import "./MentorshipPage.vue?vue&type=style&index=0&id=7140ede0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7140ede0"]])

export default __exports__